import { styled } from '@unfold/theme';
import { Button } from '@unfold/button';

export const BrandKitWrapper = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 40px;
`;

export const ImportExportButton = styled(Button)`
  position: absolute;
  top: 52px;
  right: 108px;
  padding: 3px;
`;
